import axios, { AxiosRequestConfig } from 'axios';
import { PagedResponse } from '../types/api';
import { PayoutMethod } from '../types/PayoutMethod';

const URL = '/v2/payout-method';

class PayoutMethodService {
  static findByFilter(
    config: AxiosRequestConfig
  ): Promise<PagedResponse<PayoutMethod>> {
    return axios.get(`${URL}`, config);
  }
}

export { PayoutMethodService };
